import React from 'react';
import { Modal } from '@shared/designSystem/messages/Modal';
import { HorizontalContainer, VerticalContainer } from '@shared/designSystem/Containers';
import { Text } from '@shared/designSystem/Texts';
import { HollowedButton } from '@shared/designSystem/Button';
import designSystemStyles from '@shared/styles/designSystemStyles';
import { KioskEvidenceRequest } from './KioskEvidenceModalViewModel';
import KioskEvidencePhotos from './KioskEvidencePhotos';

interface KioskEvidenceModalProps {
    request: KioskEvidenceRequest;
    hidePopup: () => void;
}

const KioskEvidenceModal = ({ request, hidePopup }: KioskEvidenceModalProps) => (
    <Modal
        isOpen={true}
        onClose={hidePopup}
        title={"Fichada con reconocimiento facial".localized()}
        maxWidth="720px"
    >
        <VerticalContainer gap={designSystemStyles.gapLg} alignment="left" width="100%">
            {request.spoofSuspected && (
                <div
                    style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        padding: designSystemStyles.paddingMd,
                        borderRadius: designSystemStyles.cornerRadius,
                        border: `1px solid ${designSystemStyles.colorWarning}`,
                        background: designSystemStyles.colorBackgroundGray2,
                    }}
                >
                    <Text
                        text={"⚠ **Posible suplantación.** El control automático marcó la foto de esta fichada como posible foto impresa o pantalla. Es una señal orientativa: compará las fotos antes de actuar.".localized()}
                        markdown={true}
                    />
                </div>
            )}
            <VerticalContainer gap={designSystemStyles.gapMd} alignment="left" width="100%">
                <HorizontalContainer justifyContent="space-between" width="100%">
                    <Text text={"Colaborador".localized()} />
                    <Text text={`**${(request.collaboratorName ?? '').trim()}**`} markdown={true} />
                </HorizontalContainer>
                <HorizontalContainer justifyContent="space-between" width="100%">
                    <Text text={"Tipo".localized()} />
                    <Text text={`**${request.recordTypeLabel}**`} markdown={true} />
                </HorizontalContainer>
                <HorizontalContainer justifyContent="space-between" width="100%">
                    <Text text={"Hora".localized()} />
                    <Text text={`**${request.timeLabel}**`} markdown={true} />
                </HorizontalContainer>
            </VerticalContainer>

            <KioskEvidencePhotos recordID={request.recordID} />

            <HorizontalContainer justifyContent={designSystemStyles.justifyContentRight} width="100%">
                <HollowedButton onClick={hidePopup} text={"Cerrar".localized()} />
            </HorizontalContainer>
        </VerticalContainer>
    </Modal>
);

export default KioskEvidenceModal;
